export const INVOICE_ACCEPT = '.pdf,.jpg,.jpeg,.png';
export const INVOICE_MAX_BYTES = 10 * 1024 * 1024;
export const INVOICE_MIME_TYPES = ['application/pdf', 'image/jpeg', 'image/png'];

// A supplier invoice filed into Google Drive. The PDF itself lives in Drive —
// this row is the index entry, and drive_url is the only way back to the file.
export interface UploadedInvoice {
  id: string;
  filename: string;
  drive_file_id: string;
  drive_url: string;
  description: string | null;
  /** ISO date. Also decides which Drive month folder the file was filed under. */
  invoice_date: string;
  amount: number | null;
  supplier_name: string | null;
  uploaded_at: string;
  uploaded_by: string | null;
}

export interface InvoicesResponse {
  invoices: UploadedInvoice[];
  /** False when the service has no Drive credentials — uploads will 503. */
  drive_configured: boolean;
}

export interface InvoiceUploadResult {
  invoice: UploadedInvoice;
  /** Where it landed, e.g. "TPC Invoices/2026/August 2026". */
  drive_path: string;
}
